<template>
  <div class="h-100">
    <header-simple />

    <v-row class="h-100">
      <landing-column />

      <v-col cols="12" md="4" sm="6" order-sm="1" class="d-flex align-start justify-center login-form-row">
        <div class="form--maxsize">
          <v-form @submit.prevent="tryResetPassword">
            <div class="elevation-0 pb-3">
              <div class="page__title" role="region" aria-label="passReset">
                <h1 id="passReset">Zresetuj hasło</h1>
                <title-decoration />
              </div>

              <!-- Przenieść do formsów a cały widok do views-->

              <div class="registerProposition separate--after" role="region" aria-labelledby="nazwa_id">
                <p id="nazwa_id">Na podany adres email zostanie wysłany link pozwalający ustalić nowe hasło</p>
              </div>

              <v-card-text class="error-top">
                <w-input placeholder="kowalski@poczta.pl" outlined append-icon="mdi-email" :model="$schema.mail" />
              </v-card-text>

              <v-card-actions class="split-buttons" role="region" aria-label="Przyciski funkcyjne">
                <v-btn large text outlined color="primary" @click="goBack">Anuluj</v-btn>

                <v-btn large elevation="0" type="submit" color="primary">Wyślij</v-btn>
              </v-card-actions>
            </div>
          </v-form>
        </div>
      </v-col>
    </v-row>

    <material-dialog
      title="Link wysłany"
      text="Kliknij w link wysłany w wiadomości e-mail, żeby zmienić hasło."
      confirm-text="Ok"
      :show="showDialog"
      :show-cancel="false"
      :width="500"
      @confirm="redirectToLogin"
    />
  </div>
</template>

<script>
import { WInput, schemaMixin } from '@witkac/vuetify-components';
import { authResource } from '@witkac/kartamiejska-resources';

import HeaderSimple from '@/components/layout/HeaderSimple';
import LandingColumn from '@/components/layout/LandingColumn';
import MaterialDialog from '@/components/material/Dialog';
import TitleDecoration from '@/components/material/TitleDecoration';
import schema from '@/schemas/resetPassword.schema';
import { serverError } from '@/utils/error';

// @vuese
// Komponent resetu hasła
// @group Material
export default {
  components: { WInput, MaterialDialog, TitleDecoration, HeaderSimple, LandingColumn },
  mixins: [schemaMixin],
  schema,
  data() {
    return {
      showDialog: false,
      model: {}
    };
  },
  methods: {
    // @vuese
    // Metoda waliduje formularz i wysyla link ze zmiana hasla
    tryResetPassword() {
      authResource
        .resetPassword(this.model.mail)
        .then(() => {
          this.showDialog = true;
        })
        .catch(error =>
          this.$store.dispatch('notifyError', {
            title: 'Nie udało się zresetować hasła.',
            messages: [serverError(error.message)]
          })
        );
    },
    // @vuese
    // Powrót do poprzedniego widoku
    goBack() {
      this.$router.go(-1);
    },
    // @vuese
    // Przekierowuje na ekran logowania
    redirectToLogin() {
      this.$router.push({ name: 'login' });
    }
  }
};
</script>
